import {mutations} from './mutations';
import {actions} from './actions';
import {getters} from './getters';

const state = {
    redemptions: [],
    available: 0,
    loading: false,
    approving: false,
    rejecting: false,
    expires: null,

    history: [],
    historyLoading: false,
    historyTableOptions: {
        page: 1,
        itemsPerPage: 10
    },
    historyTableFooterProps: {
        itemsPerPageOptions: [10, 25, 50, 100]
    },

};

export default {
    namespaced: true,

    state,
    getters,
    actions,
    mutations
}

